/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2019
 * @license MIT
 */

const ExactTrie = require('./lib/ExactTrie');
module.exports = ExactTrie;
